import moment from 'moment';
import TeamCalendarAssembler from 'vacations-absences.module/common/assemblers/teamCalendar.assembler';
import {fromRangeToArray, returnIconDays} from 'common/utils/dateUtils/date-utils';

class TeamCalendarService {

  constructor($q,
              managerYearInlineService,
              vacationDelegationService,
              vacationUserDataService) {
    'ngInject';
    this.q = $q;
    this.managerYearInlineService = managerYearInlineService;
    this.vacationDelegationService = vacationDelegationService;
    this.vacationUserDataService = vacationUserDataService;
    this.teamCalendarAssembler = new TeamCalendarAssembler();
  }

  initData(userId, year) {
    const teamCalendarData = {};
    const today = moment().format('YYYY-MM-DD');

    return this.q((resolve, reject) => {
      this.managerYearInlineService.getData(userId, year).then((response) => {
        teamCalendarData.rawEmployeeList = response;
        teamCalendarData.employeeList = response;
        teamCalendarData.employeesForSearch = this.teamCalendarAssembler.buildListFromResponse(response);

        this.vacationDelegationService.hasDelegated(userId).then(response => {
          teamCalendarData.hasDelegated = response.hasDelegated;

          if (teamCalendarData.hasDelegated) {
            teamCalendarData.delegation = this.vacationDelegationService.findDelegationActive(today, response.delegations);
          }

          return resolve(teamCalendarData);

        }).catch(error => reject(error));

      }).catch(error => reject(error));
    });
  }

  formatEmployeeList(employeeList) {
    let id = 0;
    let calendarLines = [];

    employeeList.forEach((employee) => {
      let employeeId = employee.employeeId;
      let name = employee.name;
      let iconDays = [];
      let periodInDays = [];
      let remarks = '';

      iconDays = returnIconDays(employee.periods);

      employee.periods = [...employee.periods, ...employee.localAndNationalHolidays];

      employee.periods.map((item) => {
        let startDate = item.startDate || item.date;
        let endDate = item.endDate || item.date || new Date();
        let status = item.status || '';
        let periodId = id++;
        remarks = item.remarks || remarks;
        let type = item.type || '';
        let code = item.code || '';
        periodInDays = periodInDays.concat(fromRangeToArray(startDate, endDate, status, periodId, type, code, iconDays));
      });

      let line = {employeeId, name, remarks, employee, periodInDays};
      calendarLines.push(line);
    });

    return calendarLines;
  }

  getTeamCalendarList(employeeList, date, employeeFilters) {
    const teamCalendarList = [];
    const month = date.getMonth();
    const year = date.getFullYear();

    let employeeListFiltered = employeeList;

    if (this._atLeastOneFilter(employeeFilters)) {
      employeeListFiltered = this._discardEmployeesNotInFilters(
        employeeList,
        employeeFilters
      );
    }

    employeeListFiltered.forEach(employee => {
      const periodsInDate = this._getPeriodsInMonthAndYear(employee.periods, month, year);
      this._addTeamCalendarListMatch(teamCalendarList, employee, periodsInDate);
    });

    return teamCalendarList;
  }

  _atLeastOneFilter(employeeFilters) {
    return employeeFilters.length > 0;
  }

  _discardEmployeesNotInFilters(employeeList, employeeFilters) {
    return employeeList.filter(employee => this._isPresent(employeeFilters, employee.employeeId));
  }

  _isPresent(employeeFilters, employeeId) {
    return employeeFilters.some(profile =>  profile.userId === employeeId);
  }

  _getPeriodsInMonthAndYear(periods, month, year) {

    return periods.filter(period => {

      if (period.type === 'holiday') {
        return false;
      }

      const startDate = new Date(period.startDate);
      let endDate = new Date();

      if (period.endDate) {
        endDate = new Date(period.endDate);
      }

      const periodStartMonth = startDate.getMonth();
      const periodEndMonth = endDate.getMonth();

      const monthMatch = (month === periodStartMonth) || (month === periodEndMonth);

      const periodStartYear = startDate.getFullYear();
      const periodEndYear = endDate.getFullYear();

      const yearMatch = (year === periodStartYear) || (year === periodEndYear);

      return monthMatch && yearMatch;

    });

  }

  _addTeamCalendarListMatch(teamCalendarList, employee, periodsInDate) {
    const {employeeId, name, email} = employee;
    teamCalendarList.push({employeeId, name, email, periodsInDate});
  }

}

export default TeamCalendarService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/common/services/teamCalendar.service.js